import { h } from './/index.js';
export const getKeyValue = function (obj, key) {
    return obj[key];
};
export const selectIsNotLoaded = (loadable) => {
    return h.isNotLoaded(loadable);
};
export const selectIsLoading = (loadable) => {
    return h.isLoading(loadable);
};
export const selectIsLoaded = (loadable) => {
    return h.isLoaded(loadable);
};
export const selectIsReloading = (loadable) => {
    return h.isReloading(loadable);
};
export const selectIsError = (loadable) => {
    return h.isError(loadable);
};
export const selectIsPartialLoading = (loadable) => {
    return h.isPartialLoading(loadable);
};
export const selectIsPartialError = (loadable) => {
    return h.isPartialError(loadable);
};
export const selectHasData = (loadable) => {
    return h.hasData(loadable);
};
//# sourceMappingURL=selectors.js.map